/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

const formDataPayload = payload => {
  const formData = new FormData();
  const append = (key, value) => {
    if (value === null || value === undefined || value === '') return;
    const isFile = typeof File !== 'undefined' && value instanceof File;
    const isBlob = typeof Blob !== 'undefined' && value instanceof Blob;
    if (isFile || isBlob) {
      formData.append(`identity_verification[${key}]`, value);
      return;
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        if (nestedValue !== null && nestedValue !== undefined) {
          formData.append(
            `identity_verification[${key}][${nestedKey}]`,
            nestedValue
          );
        }
      });
      return;
    }
    formData.append(`identity_verification[${key}]`, value);
  };

  Object.entries(payload).forEach(([key, value]) => append(key, value));
  return formData;
};

class IdentityVerificationsAPI extends ApiClient {
  constructor() {
    super('identity_verifications', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  reviewQueue(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'review_queue'), params),
      requestConfig()
    );
  }

  providerReadiness(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'provider_readiness'), params),
      requestConfig()
    );
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  createWithDocuments(payload = {}) {
    return axios.post(this.url, formDataPayload(payload), requestConfig());
  }

  review(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'review'),
      { risk_decision: payload },
      requestConfig()
    );
  }

  requestCreditAssessment(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'credit_assessment'),
      { credit_assessment: payload },
      requestConfig()
    );
  }

  signedUrl(documentArtifactId, payload = {}) {
    return axios.post(
      resourcePath(
        this.accountScopedPath(),
        'document_artifacts',
        documentArtifactId,
        'signed_url'
      ),
      payload,
      requestConfig()
    );
  }

  accountScopedPath() {
    return this.url.replace(/\/identity_verifications$/, '');
  }
}

export default new IdentityVerificationsAPI();
